<template>
  <div>
    <!-- 기본정보 -->
    <field-select-module v-model="form.stdInfo" :board="this.board" :is-print="isPrint" />

    <!-- 보호구 지급 및 관리 현황 -->
    <table-custom
      :board="board"
      :is-print="isPrint"
      title="보호구 지급 및 관리 현황"
      :tableData="[
        { id: 'input1', title: '연번', type: 'no', placeholder: '내용', width: '50px' },
        { id: 'input2', title: '보호구명', type: 'text', placeholder: '내용' },
        { id: 'input3', title: '부서명', type: 'text', placeholder: '내용' },
        { id: 'input4', title: '개수', type: 'text', placeholder: '내용' },
        { id: 'input5', title: '수령자', type: 'text', placeholder: '내용' },
        { id: 'input6', title: '서명', type: 'sign', placeholder: '서명' },
        { id: 'input7', title: '지급시기', type: 'text', placeholder: '내용' },
      ]"
      v-model="form.equipList"
      @input="inputEquip"
    />

    <!-- 사진대지 -->
    <photo-upload-grid-module
      :row-count="2"
      :grid-count="2"
      v-model="form.photoList"
      :is-print="isPrint"
      :readonly="board.readonly"
      section-title="사진대지"
      placeholder="신축현장 점검"
    />

    <!-- 파일첨부 -->
    <file-upload-module id="fileList" class="w-full mt-4" v-model="form.fileList" :is-print="isPrint" :readonly="board.readonly" />

  </div>
</template>

<script>
import FileUploadModule from "@/views/modules/FileUploadModule";
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import TableInspect from "@/components/TableInspectNo";
import DateSelector from "@/components/selector/DateSelector";
import CompanySelector from "@/components/selector/CompanySelector";
import TableCustom from "@/components/TableCustom.vue";
import PhotoUploadGridModule from "@/views/modules/PhotoUploadGridModule.vue";

export default {
  components: {
    PhotoUploadGridModule,
    TableCustom,
    FieldSelectModule,
    FileUploadModule,
    TableInspect,
    DateSelector,
    CompanySelector,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        value.title = this.board.writer.department;
        this.$emit("input", value);
      },
    },
  },
  data() {
    return {
      form: {
        stdInfo: {},
        equipList: [ { "id": 1, "input2": "", "input3": "", "input4": "", "input5": "", "input6": "", "input7": "" } ],
        photoList: [],
        fileList: [],

        protectors: "",
        receivers: "",
      },
    };
  },
  methods: {
    inputEquip(v) {
      this.form.protectors = v.map((item) => item.input2).join(", ");
      this.form.receivers = v.map((item) => item.input5).join(", ");
    },
  },
};
</script>

<style scoped lang="scss">
#PopupTable {
  width: 100%;
  border-collapse: collapse;

  &,
  tr,
  th,
  td {
    border: 1px solid #cdcdcd;
  }

  th {
    font-weight: 700;
    font-size: 16px;
    line-height: 23px;
    text-align: center;
    background: #f9f9f9;
    padding: 10px 0;
  }

  li {
    margin-left: 16px;
    &::marker {
      content: " · ";
      font-size: 1.2em;
    }
  }
}
</style>
